import {ColumnsType} from "antd/lib/table";
import {ProductStatisticsDto} from "../../api";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {CrudTable, nameof} from "digimuth-components/dist";

export default function ProductStatisticsList(props: CrudTableWrapperProps<ProductStatisticsDto>) {
    const columns: ColumnsType<ProductStatisticsDto> = [
        {
            key: nameof<ProductStatisticsDto>("header"),
            dataIndex: nameof<ProductStatisticsDto>("header"),
            title: "Nagłówek"
        },
        {
            key: nameof<ProductStatisticsDto>("content"),
            dataIndex: nameof<ProductStatisticsDto>("content"),
            title:"Tekst"
        },
    ];

    return <>
        <CrudTable
            data={props.data}
            onAddClicked={props.onAddClicked}
            onEditClicked={props.onEditClicked}
            onDeleteClicked={props.onDeleteClicked}
            isLoading={props.isLoading}
            columns={columns}
            addButtonTitle={"+ Dodaj nową statystykę"}
            editButtonTitle={"Edytuj"}
            deleteButtonTitle={"Usuń"}
            deleteConfirmMessage={"Czy na pewno chcesz usunąć ten wpis?"}
            cancelButtonTitle={"Anuluj"}
        />
    </>
}
